// extracted by mini-css-extract-plugin
module.exports = {"content":"ProjectDiscountMovileViewColumn_content__C0yAw","actions":"ProjectDiscountMovileViewColumn_actions__HEpFX"};